export default function(productCode) {
   const map = {
    "26010": "#e6f2ff", // Softer red
    "22010": "#fff2e6", // Softer orange
    "25010": "#ffffe6", // Softer yellow
    "24010": "#e6ffe6", // Softer green
    "24610": "#ffe6e6", // Softer blue
    "27213": "#f2e6ff", // Softer purple
    "27200": "#ffe6f2", // Softer pink
    "28411": "#ffece6", // Softer coral
    "2A210": "#fffff2", // Softer cream
    "2B610": "#f2fff2", // Softer mint
    "24612": "#f2fcff", // Softer cyan
    "22016": "#fcf2ff", // Softer lavender
    "22017": "#fff2fc"  // Softer rose
  }
  
  return map[productCode] || "#ffffff"; // Default color if not found
}